import { useEffect, useState } from "react";
import { __ } from '@wordpress/i18n';

const WPLoginForm = ( {onClickAccountForm, onClickResetPassword, handleCacheLoginForm, cacheValue=""} ) => {

  const [formHtml, setFormHtml] = useState("");
  

  const showResetPasswordForm = (e) => {

    e.preventDefault();
    onClickResetPassword((isActive) => !isActive);

  }

  const showCreateAccountForm = (e) => {
    e.preventDefault();
    onClickAccountForm((isActive) => !isActive);
  }



  useEffect(() => {

    if (cacheValue) {
      setFormHtml(cacheValue);
      return;
    }
    
    fetch(hive_front.ajaxurl, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams({
        action: "hive_support_get_wp_login_form",
        nonce: hive_front.security,
        page_url: window.location.href, // Add additional data here
      })
    })
      .then((res) => res.text())
      .then((html) => {
        handleCacheLoginForm(html);
        setFormHtml(html)
        

      })
      .catch((err) => console.error("Error fetching login form:", err));
  }, [formHtml]);


  return (
    formHtml && <>
      <h4 class="hs-login-form-title">{hive_front.non_logged_user_msg}</h4>
      <div class="hs-login-form">
      <div dangerouslySetInnerHTML={{ __html: formHtml }} />
      <div class="hs-login-form-footer">
        <p>{__( "Not registered?", "hive-support" )} <a onClick={showCreateAccountForm} href="#">{__( "Create an account", "hive-support" )}</a></p>
        <p>{__( "Forgot your password?", "hive-support" )} <a onClick={showResetPasswordForm} href="#">{__( "Reset password", "hive-support" )}</a></p>
      </div>
      </div>
      </>
  );
};

export default WPLoginForm;
